import Image from "next/image"
import Link from "next/link"
import logoSvg from "@/assets/svg/logo.svg"
import logoIcon from "@/assets/svg/logo_vectorized.svg"
import { cn } from "@/app/utils"

export const Logo = ({ className }: { className?: string }) => {
  return (
    <div className={cn("relative w-60 h-16", className)}>
      <Link href="/">
        <Image
          src={logoSvg}
          alt="Logo"
          fill
          className="object-contain filter dark:invert"
        />
      </Link>
    </div>
  )
}

export const LogoIcon = () => (
  <div className="relative w-60 h-14">
    <Image
      src={logoIcon}
      alt="Logo"
      fill
      className="object-contain filter dark:invert"
      priority
    />
  </div>
);